<template>
	<div class="page">
		<MainHeader v-bind:page="'Scholing'"></MainHeader>
		<div class="container">
			<div class="row">
				<div class="whole component">
					<img :src="headerImage" width="938px" />
					<h1>Scholing</h1>
					<p class="highlight">Door de beroepsopleiding TOPKI zijn de volgende scholingen geaccrediteerd die door mij worden verzorgd.</p>
					<p><b>Agenda Scholing:</b> Studenten Topki en agenda nascholing Themadagen zie <a href="https://www.topki.nl/trainer/suzette-frijters">www.topki.nl/trainer/suzette-frijters</a><br>
					Aanmelden graag via deze link.<br>
					Heeft u vragen dan graag een mail of telefoontje naar Suzette Frijters<br>
					tel 0653574848</p>

					<h2>Persoonlijke Supervisie voor studenten in opleiding </h2>

					<p>Voor studenten aan de beroepsopleiding TOPKI is Persoonlijke Supervisie een verplicht onderdeel in de opleiding. Dit traject is bestemd voor de ondersteuning en ontwikkeling van het persoonlijke groeiproces.</p>
					
					<h2>Module Communicatie en Counseling met het Talentenspel voor studenten in opleiding.</h2>
					<p>De module <router-link to="/scholing/module-communicatie-counseling">Communicatie en Counseling</router-link> aan de beroepsopleiding TOPKI bestaat uit vier modules, van elk één dag. In deze vier dagen wordt er gewerkt met het Talentenspel.
						<ul>
							<li>Dag 1: Talenten ontmoeten</li>
							<li>Dag 2: De Levensboom</li>
							<li>Dag 3: De Piramide</li>
							<li>Dag 4: De Zielespiegel</li>
						</ul></p>
				</div>
			</div>
			<div class="row">
				<div class="quarter component">
					<img :src="wereldBord" class="gameboard-small" />
				</div>
				<div class="quarter component">
					<img :src="levensboomBord" class="gameboard-small" />
				</div>
				<div class="quarter component">
					<img :src="piramideBord" class="gameboard-small" />
				</div>
				<div class="quarter component">
					<img :src="zielespiegelBord" class="gameboard-small" />
				</div>
			</div>
			<div class="row">
				<div class="whole component">
					<h2>Nascholing </h2>
					<p>Aangesloten bij de Beroepsopleiding Topki bied ik de mogelijkheden aan voor therapeuten van het VNT en BVK om het Talentenspel te volgen als <router-link to="/scholing/nascholing">nascholing</router-link>.</p>

					<h2>Accredatie</h2>
					<p>De beroepsopleiding <a href="http://www.topki.nl/trainer/suzette-frijters">TOPKI</a> is door de SNRO geaccrediteerd. Voor deze beroepsopleiding verzorg ik een aantal scholingsprogramma’s. </p>
					<p>De beroepsopleiding TOPKI voldoet aan de internationale voorwaarden van het International Kinesiology College en werkt samen met verschillende nationale- en internationale trainers. In 2012 is de opleiding erkend door de FONG op HBO-niveau. Sinds 2017 heeft de beroepsopleiding TOPKI het keurmerk: FONG.SNRO erkende HBO-opleiding.</p>
                </div>
            </div>
		</div>
		<MainFooter style="display:flex; margin-left: auto; margin-right:auto;"></MainFooter>
	</div>
</template>

<script>
import MainHeader from '../MainHeader';
import MainFooter from '../MainFooter';

export default {
	name: 'Scholing',
	data() {
		return {
			headerImage: require('../../img/scholing_header.jpg'),
			wereldBord: require('../../img/wereldbord_nl.jpg'),
			levensboomBord: require('../../img/levensboombord_nl.jpg'),
			piramideBord: require('../../img/piramidebord_nl.jpg'),
			zielespiegelBord: require('../../img/zielespiegelbord_nl.jpg'),
			ktno_nascholing: require('../../img/ktno_nascholing.png'),
			ktno_module: require('../../img/ktno_module.png')
		}
	},
	computed: {
	},
	methods: {
	},
	components: {
		MainHeader, MainFooter
	}
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Scholing.vue